import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { hasNavPermission } from '../components/ProtectedRoute';
import './AdminHubPage.css';

const SECTIONS = [
  { to: '/settings', icon: '⚙️', label: 'Ajustes', desc: 'Nombre del grupo, contacto, mensaje de bienvenida', key: 'admin_settings' },
  { to: '/companies', icon: '🏢', label: 'Empresas', desc: 'Administrar las empresas miembro', key: 'admin_companies' },
  { to: '/farms', icon: '🚜', label: 'Fincas', desc: 'Administrar las fincas por empresa', key: 'admin_farms' },
  { to: '/bunch-sleevers', icon: '🍌', label: 'Enfundadores', desc: 'Administrar los enfundadores por finca', key: 'admin_bunch_sleevers' },
  { to: '/ribbons', icon: '🎀', label: 'Cintas', desc: 'Administrar los colores de cinta', key: 'admin_ribbons' },
  { to: '/exporters', icon: '🚢', label: 'Exportadores', desc: 'Administrar los exportadores', key: 'admin_exporters' },
  { to: '/brands', icon: '🏷️', label: 'Marcas', desc: 'Administrar las marcas', key: 'admin_brands' },
  { to: '/transportations', icon: '🚚', label: 'Transportes', desc: 'Administrar los transportes', key: 'admin_transportations' },
  { to: '/destinations', icon: '📍', label: 'Destinos', desc: 'Administrar los destinos', key: 'admin_destinations' },
  { to: '/drivers', icon: '🧑‍✈️', label: 'Conductores', desc: 'Administrar los conductores', key: 'admin_drivers' },
  { to: '/box-types', icon: '📦', label: 'Tipos de Caja', desc: 'Administrar los tipos de caja', key: 'admin_box_types' },
  { to: '/inspectors', icon: '🔍', label: 'Inspectores', desc: 'Administrar los inspectores', key: 'admin_inspectors' },
  {
    to: '/fumigation-products', icon: '🧪', label: 'Productos de Fumigación',
    desc: 'Administrar los productos de fumigación', key: 'admin_fumigation_products',
  },
  {
    to: '/fumigation-companies', icon: '🛩️', label: 'Empresas de Fumigación',
    desc: 'Administrar las empresas de fumigación', key: 'admin_fumigation_companies',
  },
  {
    to: '/fumigation-pilots', icon: '🧑‍✈️', label: 'Pilotos de Fumigación',
    desc: 'Administrar los pilotos y su empresa de fumigación', key: 'admin_fumigation_pilots',
  },
  { to: '/users', icon: '👥', label: 'Usuarios', desc: 'Administrar cuentas de usuario y roles', key: 'admin_users' },
];

export default function AdminHubPage() {
  const { user } = useAuth();
  const visibleSections = SECTIONS.filter((s) => hasNavPermission(user, s.key));

  return (
    <div className="admin-hub-root">
      <h1 className="admin-hub-title">⚙️ Administración</h1>
      <div className="admin-hub-grid">
        {visibleSections.map((s) => (
          <Link key={s.to} to={s.to} className="admin-hub-card">
            <span className="admin-hub-icon">{s.icon}</span>
            <div>
              <div className="admin-hub-label">{s.label}</div>
              <div className="admin-hub-desc">{s.desc}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
